import { Injectable, OnDestroy } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { TranslateService } from "@ngx-translate/core";
import { ToastService } from "./ToastService.service";

/** Polls the service worker for new versions and prompts the user to reload. */
@Injectable({
  providedIn: "root"
})
export class CheckForUpdateService implements OnDestroy {
  updateCheckInterval: any;
  updateCheckTimer: number = 60 * 1000;
  // updateSub: Subscription;

  constructor(
    private readonly ToastService: ToastService,
    private readonly translate: TranslateService,
    private readonly update: SwUpdate
  ) {}

  ngOnDestroy(): void {
    clearInterval(this.updateCheckInterval);
  }

  // Notify when a new version is available
  startChecking(): void {
    if (this.update.isEnabled) {
      this.chekUpdate();
      this.updateCheckInterval = setInterval(() => this.chekUpdate(), this.updateCheckTimer);
    }
  }

  chekUpdate(): void {
    this.update.checkForUpdate().then(update => {
      if (update) {
        this.ToastService.fireToastWithConfirmation(
          "info",
          this.translate.instant("new-version-available"),
          this.translate.instant("update"),
          this.translate.instant("cancel")
        ).then((userConfirmation: boolean) => {
          if (userConfirmation) {
            document.location.reload();
          }
        });
      }
    });
  }
}
